<script setup>
import useCalculatorStore from '../store/calculator.js';

const calculator = useCalculatorStore();
</script>

<template>
  <select class="form-select__select" @change="calculator.selectedProgram = $event.target.value">
    <option
      v-for="program in calculator.programs"
      :key="program.id"
      :selected="program.id === calculator.selectedProgram"
      :value="program.id"
    >
      {{ program.name }}
    </option>
  </select>
</template>
